import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import {
  useCancelConsultInvoiceId,
  useConsultInvoiceId,
} from '@/core/domain/invoice/invoice/invoice.hooks';
import {
  ConsultInvoiceStatus,
  InvoiceConsultTecnoSpeedRef,
  InvoiceResponseError,
} from '@/core/domain/invoice/invoice/Invoice.types';
import { Button, Modal } from 'antd';
import { AxiosError } from 'axios';
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { FaTimes } from 'react-icons/fa';
import { transmissionTextFormat } from '../../options';

export const InvoiceConsultTecnoSpeed = forwardRef<
  InvoiceConsultTecnoSpeedRef,
  unknown
>((_, ref) => {
  const {
    invoiceId,
    invoice: { data: invoice },
  } = useInvoiceFormContext();

  const cancelConsultInvoiceId = useCancelConsultInvoiceId();
  const consultInvoiceId = useConsultInvoiceId();

  const hasPlugNotasId = !!invoice?.plugNotasId;

  const [isConsultingInvoice, setIsConsultingInvoice] =
    useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timer;

    if (isConsultingInvoice) {
      interval = setInterval(consultInvoice, 20000);
    }

    return () => clearInterval(interval);
  }, [isConsultingInvoice]);

  const consultInvoice = async () => {
    try {
      setIsConsultingInvoice(true);
      if (invoice?.situation === 'PROCESSING_CANCELLATION') {
        await cancelConsultInvoiceId.mutateAsync(Number(invoiceId));
        setIsConsultingInvoice(false);
        return;
      }

      const response = await consultInvoiceId.mutateAsync(Number(invoiceId));

      if (response.status !== ConsultInvoiceStatus.processando) {
        setIsConsultingInvoice(false);
      }

      if (
        response.message &&
        !['RPS Autorizada com sucesso', 'Autorizado o uso da NF-e'].includes(
          response.message,
        )
      ) {
        setIsConsultingInvoice(false);
        Modal.confirm({
          width: '80%',
          title: 'Campos necessários para a transmissão da nota.',
          content: (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {transmissionTextFormat(response.message)}
            </div>
          ),
          okText: 'Fechar',
          cancelButtonProps: { hidden: true },
        });
      }
    } catch (error) {
      const err = error as AxiosError<InvoiceResponseError>;

      if (
        err.response?.data.error.message.includes(
          'Cancelamento em processamento',
        )
      ) {
        setIsConsultingInvoice(true);
      } else {
        setIsConsultingInvoice(false);
      }
    }
  };

  useImperativeHandle(ref, () => ({
    consultInvoice,
  }));

  return (
    <Button.Group style={{ width: '100%' }}>
      <>
        {hasPlugNotasId && (
          <Button
            loading={consultInvoiceId.isLoading || isConsultingInvoice}
            block
            type="primary"
            onClick={consultInvoice}
          >
            {isConsultingInvoice ? 'Consultando...' : 'Consultar Situação'}
          </Button>
        )}

        {isConsultingInvoice && (
          <Button
            style={{ padding: '0px 8px 0px 10px' }}
            type="primary"
            danger
            onClick={() => setIsConsultingInvoice(false)}
          >
            <FaTimes />
          </Button>
        )}
      </>
    </Button.Group>
  );
});
